import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 200px);
  width: 100%;
  padding: 2rem;
  animation: fadeIn 0.6s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  width: 100%;
`;

export const TitleBig = styled.h1`
  color: ${(props) => props.theme.colors.blue.darkest};
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
  margin: 0 0 0.75rem 0;
`;

export const TitleSmall = styled.p`
  color: #6b7280;
  font-size: 1rem;
  text-align: center;
  margin: 0 0 2.5rem 0;
  line-height: 1.5;
`;

export const Img404 = styled.img`
  max-height: 300px;
  max-width: 100%;
  object-fit: contain;
  margin: 0 0 3rem 0;
  opacity: 0.95;

  @media (max-width: 768px) {
    max-height: 220px;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: ${(props) => props.theme.colors.blue.darkest};
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1.75rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.colors.blue.dark};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  span {
    line-height: 1;
  }
`;
